<template>
  <div class="readMe ql-editor readOrder-warp">
    <div v-if="!isParentApp" class="header-title-pub">
      <a class="back-btn" href="javascript:history.go(-1);"></a>
      <p>课程购买协议</p>
    </div>
    <div :class="['content', isParentApp ? 'has-mobile' : '']">
      <div v-html="readMeCont"></div>
    </div>
  </div>
</template>
<script>
import appUtil from "../../utils/appUtil";
export default {
  data() {
    return {
      readMeCont: "",
      isParentApp: true,
    };
  },
  created() {
    this.isParentApp = new appUtil().isParentApp();
  },
  mounted() {
    this.fetchs();
  },
  methods: {
    unescape(html) {
      if (html) {
        return html
          .replace(/&(?!#?\w+;)/g, "&amp;")
          .replace(/&lt;/g, "<")
          .replace(/&gt;/g, ">");
      }
    },
    fetchs() {
      this.$api.my.changeReadMe().then((res) => {
        if (res.errcode == 0) {
          var content = this.unescape(res.data.content);
          this.readMeCont = content;
        } else {
          this.$toast(res.msg);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.readOrder-warp {
  padding: 0 20px 20px;
  min-height: 105%;
  background: #fff;
  line-height: 20px;
  .header-title-pub {
    width: 100%;
    height: 44px;
    line-height: 44px;
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    color: #111111;
    font-size: 18px;
    background: #fff;
    .back-btn {
      width: 12px;
      height: 20px;
      background: url("../../assets/img/back_btn.png") no-repeat;
      -webkit-background-size: 100%;
      background-size: 100%;
      position: absolute;
      top: 12px;
      left: 16px;
    }
  }
  .content {
    padding-top: 44px;
    p {
      font-size: 14px !important;
      color: #666;
      line-height: 22px !important;
    }
    &.has-mobile {
      padding-top: 20px;
    }
  }
  &.read-mobile {
    .header-title-pub {
      display: none;
    }
    .content {
      padding-top: 10px;
    }
  }
}
</style>
